import type { ConsultationCode } from '../types/consultation'

/**
 * API / legacy rows may store diagnosis as a string or non-array; normalize for forms and workspace.
 */
export function normalizeDiagnosisList(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((d) => String(d).trim()).filter(Boolean)
  }
  if (typeof value === 'string' && value.trim()) {
    return [value.trim()]
  }
  return []
}

const VALID_CODE_SYSTEMS = new Set(['ICPC2', 'ICD10', 'LOCAL', 'TEMP'])

export function normalizeCodesList(value: unknown): ConsultationCode[] {
  if (!Array.isArray(value)) return []
  return value.filter(
    (c): c is ConsultationCode =>
      !!c &&
      typeof c === 'object' &&
      VALID_CODE_SYSTEMS.has(String((c as ConsultationCode).system)) &&
      typeof (c as ConsultationCode).code === 'string' &&
      typeof (c as ConsultationCode).display === 'string',
  )
}
